import Navbar from "./components/Navbar";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import CampusListPage from "./pages/CampusListPage";
import YearsListPage from "./pages/YearsListPage";
import CompilerPage from "./pages/CompilerPage";
import CourseListPage from "./pages/CourseListPage";
import CategoryListPage from "./pages/CategoryListPage";
import QuestionListPage from "./pages/QuestionListPage";
import SolveQuestionPage from "./pages/SolveQuestionPage";
import QuestionUploadPage from "./pages/QuestionUploadPage";
import LoginPage from "./pages/LoginPage";
import CreateAdminPage from "./pages/CreateAdminPage";
import ProtectedRoute from "./components/ProtectedRoute";
import BatchListPage from "./pages/BatchListPage";
import SubmissionListPage from "./pages/SubmissionListPage";
import MCQListPage from "./pages/MCQListPage";
import MCQCreatePage from "./pages/MCQCreatePage";
import MCQStudentPage from "./pages/MCQStudentPage";
import MCQTestPage from "./pages/MCQTestPage";
import ComingSoon from "./pages/ComingSoon";
import MCQReportPage from "./pages/MCQReportPage";
import CreateStudent from "./pages/CreateStudent";
import AssignCourseOrMcq from "./pages/AssignCourseOrMcq";
import CreateAssignmentPage from "./pages/CreateAssignmentPage";
import AssignmentListPage from "./pages/AssignmentListPage";
import AssignmentStudentPage from "./pages/AssignmentStudentPage";
import AssignmentSolvePage from "./pages/AssignmentSolvePage";
import AssignmentSolveQuestionPage from "./pages/AssignmentSolveQuestionPage";
import ViewStudentCampusListPage from "./pages/ViewStudentCampusListPage";
import ViewStudentYearListPage from "./pages/ViewStudentYearListpage";
import ViewStudentBatchListPage from "./pages/ViewStudentBatchListPage";
import ViewStudentsByBatch from "./pages/ViewStudentsByBatch";
import StudentTickets from "./pages/StudentTickets";
import AdminTickets from "./pages/AdminTickets";
import DashboardPage from "./pages/DashboardPage";
import CourseListPageLibrary from "./pages/CourseListPageLibrary";
import AssignmentListPageLibrary from "./pages/AssignmentListPageLibrary";
import MCQListPageLibrary from "./pages/MCQListPageLibrary";
import ViewAssignmentReport from "./pages/ViewAssignmentReport";
import ViewMcqsAnswer from "./pages/ViewMcqsAnswer";
import MCQCategoryPage from "./pages/MCQCategoryPage";
import MCQListByCategory from "./pages/MCQListByCategory";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AssignmentDetailPage from "./pages/AssignmentDetailPage";
import AssessmentSelectPage from "./pages/AssessmentSelectPage";
import StaffAssignmentList from "./pages/StaffAssignmentList";
import StaffMCQList from "./pages/StaffMCQList";
import AssignmentReportPage from "./pages/AssignmentReportPage";
import MCQReportPageStaff from "./pages/MCQReportPageStaff";
import CreateStaffPage from "./pages/StaffManagementPage";
import TSSCurriculumDashboard from "./pages/TSSCurriculumDashboard";
import TaskTracker from "./pages/TaskTracker";
import StudentTaskTracker from "./pages/StudentTaskTracker"
import TaskSubmissions from "./pages/TaskSubmissions";
import AssignmentsReportAssignmentList from "./pages/AssignmentsReportAssignmentList";
import AssignmentSubmissionsReport from "./pages/AssignmentSubmissionsReport";
import ReportMCQListPage from "./pages/ReportMCQListPage";
import MCQSubmissionReportPage from "./pages/MCQSubmissionReportPage";
import StudyMaterialForm from "./pages/StudyMaterialForm";
import StudyMaterialList from "./pages/StudyMaterialList";
import StudyMaterialDetail from "./pages/StudyMaterialDetail";
import StudentStudyMaterialList from "./pages/StudentStudyMaterialList";
import StudentStudyMaterialDetail from "./pages/StudentStudyMaterialDetail";
import Whiteboard from "./pages/Whiteboard";
import MCQLibraryPage from "./pages/MCQLibraryPage";
import CreateMCQPage from "./pages/CreateMCQPage";
import LeetCodeProfilePage from "./pages/LeetCodeProfilePage";
import StudentLeetCodeList from "./pages/StudentLeetCodeList";
import CampusStudents from "./pages/CampusStudents";
// import VideoPage from "./pages/VideoPage";
// import ViewStudyCourses from "./pages/ViewStudyCourses";
// import TopPerformersDashboard from "./pages/TopPerformersDashboard";
import "./App.css";
import { getRole } from "./utils/auth";

const ADMIN_ROLES = ["admin", "subadmin"];

function RoleBasedHome() {
  const role = getRole();
  if (role === "staff") {
    return <Navigate to="/select-assessment" replace />;
  }
  return <CompilerPage />;
}

export default function App() {
  const location = useLocation();
  const hideNavbar = location.pathname === "/login";

  return (
    <>
      {hideNavbar ? (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      ) : (
        <div className="app-layout">
          <Navbar />

          <main className="main-content">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              {/* ✅ Compiler (Admin + Student) */}
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <RoleBasedHome />
                  </ProtectedRoute>
                }
              />

              {/* ✅ Practice (Admin + Student) */}
              <Route
                path="/courses"
                element={
                  <ProtectedRoute allowedRoles={[...ADMIN_ROLES, "student"]}>
                    <CourseListPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/view-mcqs-answer"
                element={
                  <ProtectedRoute allowedRoles={[...ADMIN_ROLES, "student"]}>
                    <ViewMcqsAnswer />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/manage-all-students"
                element={
                  <ProtectedRoute allowedRoles={[...ADMIN_ROLES, "student"]}>
                    <CampusStudents />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/view-all-material"
                element={
                  <ProtectedRoute allowedRoles={[...ADMIN_ROLES, "student"]}>
                    <StudyMaterialList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/material/:id"
                element={
                  <ProtectedRoute allowedRoles={[...ADMIN_ROLES, "student"]}>
                    <StudyMaterialDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="view-study-material"
                element={
                  <ProtectedRoute allowedRoles={[...ADMIN_ROLES, "student"]}>
                    <StudentStudyMaterialList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/study-material-content"
                element={
                  <ProtectedRoute allowedRoles={[...ADMIN_ROLES, "student"]}>
                    <StudentStudyMaterialDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/courses/:courseId/categories"
                element={
                  <ProtectedRoute allowedRoles={[...ADMIN_ROLES, "student"]}>
                    <CategoryListPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/assignments/:id" element={
                <ProtectedRoute>
                  <AssignmentDetailPage />
                </ProtectedRoute>
              } />

              <Route
                path="/categories/:categoryId"
                element={
                  <ProtectedRoute allowedRoles={[...ADMIN_ROLES, "student"]}>
                    <QuestionListPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/questions/:id"
                element={
                  <ProtectedRoute allowedRoles={[...ADMIN_ROLES, "student"]}>
                    <SolveQuestionPage />
                  </ProtectedRoute>
                }
              />

              {/* 🔒 Admin Only */}
              <Route
                path="/admin/upload"
                element={
                  <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                    <QuestionUploadPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/edit/:questionId"
                element={
                  <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                    <QuestionUploadPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/assignments/create"
                element={
                  <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                    <CreateAssignmentPage />
                  </ProtectedRoute>
                }
              />

              <Route
                  path="/assignments/solve/:assignmentId/question/:questionId"
                  element={
                    <ProtectedRoute>
                      <AssignmentSolveQuestionPage />
                    </ProtectedRoute>
                  }
                />

              <Route
                path="/mcqs/test/:mcqId"
                element={
                  <ProtectedRoute>
                    <MCQTestPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/create"
                element={
                  <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                    <CreateAdminPage />
                  </ProtectedRoute>
                }
              />
              
              <Route path="/mcqs" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <MCQListPage />
                </ProtectedRoute>
              } />

              {/* <Route path="/admin/reports/top-perfomer" element={
                <ProtectedRoute>
                  <TopPerformersDashboard />
                </ProtectedRoute>
              } /> */}

              <Route path="/mcqs/create" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <MCQCreatePage />
                </ProtectedRoute>
              } />
              
              <Route path="/mcqs/student" element={
                <ProtectedRoute>
                  <MCQStudentPage />
                </ProtectedRoute>
              } />

              <Route path="/admin/reports" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <CampusListPage />
                </ProtectedRoute>
              } />
              <Route path="/years" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <YearsListPage />
                </ProtectedRoute>
              } />
              <Route path="/submissions" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <SubmissionListPage />
                </ProtectedRoute>
              } />
              <Route path="/batches" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <BatchListPage />
                </ProtectedRoute>
              } />
               <Route path="/comingsoon" element={
                <ProtectedRoute>
                  <ComingSoon />
                </ProtectedRoute>
              } />
               <Route path="/report/mcqs" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <MCQReportPage />
                </ProtectedRoute>
              } />
                <Route path="/create-student" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <CreateStudent />
                </ProtectedRoute>
              } />
                <Route path="/manage-curriculam" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <AssignCourseOrMcq />
                </ProtectedRoute>
              } />
                <Route path="/tss-library-dashboard" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <DashboardPage />
                </ProtectedRoute>
              } />
                <Route path="/courses-library" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <CourseListPageLibrary />
                </ProtectedRoute>
              } />
                <Route path="/assignments-library" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <AssignmentListPageLibrary />
                </ProtectedRoute>
              } />
                <Route path="/mcqs-library" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <MCQListPageLibrary />
                </ProtectedRoute>
              } />
              <Route path="*" element={<Navigate to="/" />} />
              <Route path="/mcqs-list-all" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <MCQCategoryPage />
                </ProtectedRoute>
              } />
              <Route path="/mcqs/category/:category" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <MCQListByCategory />
                </ProtectedRoute>
              } /> 
              <Route path="/forgot-password" element={
                <ProtectedRoute>
                  <ForgotPasswordPage />
                </ProtectedRoute>
              } />
              <Route path="/reset-password/:token" element={
                <ProtectedRoute>
                  <ResetPasswordPage />
                </ProtectedRoute>
              } />
              <Route path="/select-assessment" element={
                <ProtectedRoute>
                  <AssessmentSelectPage />
                </ProtectedRoute>
              } />
              <Route path="/staff/assignments" element={
                <ProtectedRoute>
                  <StaffAssignmentList />
                </ProtectedRoute>
              } />
              <Route path="/whiteboard" element={
                <ProtectedRoute>
                  <Whiteboard />
                </ProtectedRoute>
              } />
              <Route path="/staff/mcqs" element={
                <ProtectedRoute>
                  <StaffMCQList />
                </ProtectedRoute>
              } />
              <Route path="/staff/assignment-report" element={
                <ProtectedRoute>
                  <AssignmentReportPage />
                </ProtectedRoute>
              } />
              <Route path="/staff/mcq-report" element={
                <ProtectedRoute>
                  <MCQReportPageStaff />
                </ProtectedRoute>
              } />
              <Route path="/create-staff" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <CreateStaffPage />
                </ProtectedRoute>
              } />
              <Route path="/tss-curriculum-dashboard" element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <TSSCurriculumDashboard />
                </ProtectedRoute>
              } />
              <Route 
                path="/admin/reports/mcq-list" 
                element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <ReportMCQListPage />
                </ProtectedRoute>
                }
                />

                <Route
                  path="/admin/reports/mcq/:mcqId"
                  element={
                  <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                    <MCQSubmissionReportPage />
                  </ProtectedRoute>
                  }
                />

                <Route
                  path="/library/mcqs"
                  element={
                  <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                    <MCQLibraryPage />
                  </ProtectedRoute>
                  }
                />

                <Route
                  path="/create-mcq-library"
                  element={
                  <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                    <CreateMCQPage />
                  </ProtectedRoute>
                  }
                />

              <Route
                path="/assignments/viewall" 
                element={
                  <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                    <AssignmentListPage /> 
                  </ProtectedRoute>
                }
              />
              <Route
                path="/assignment-student"
                element={
                  <ProtectedRoute>
                    <AssignmentStudentPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/leetcode-profile"
                element={
                  <ProtectedRoute>
                    <LeetCodeProfilePage />
                  </ProtectedRoute>
                }
              />
              <Route
              path="/assignments/solve/:assignmentId"
              element={
                <ProtectedRoute>
                  <AssignmentSolvePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-students-campus"
              element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <ViewStudentCampusListPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-students-year"
              element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <ViewStudentYearListPage />
                </ProtectedRoute>
              }
            />
            {/* <Route
              path="/video-materials"
              element={
                <ProtectedRoute>
                  <VideoPage />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path="/view-students-batches"
              element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <ViewStudentBatchListPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-students-batches-students"
              element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <ViewStudentsByBatch />
                </ProtectedRoute>
              }
            />
            <Route
              path="/raise-ticket"
              element={
                <ProtectedRoute>
                  <StudentTickets />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-all-tickets"
              element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <AdminTickets />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/reports/assignments/:assignmentId"
              element={
              <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                <AssignmentSubmissionsReport />
              </ProtectedRoute>
              }
            />
            <Route
              path="/student-tracker"
              element={
                <ProtectedRoute>
                  <StudentTaskTracker />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tss-tracker"
              element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <TaskTracker />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-task-submissions"
              element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <TaskSubmissions />
                </ProtectedRoute>
              }
            />
            
            <Route
                path="/view-assignment-report"
                element={
              <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <ViewAssignmentReport />
                </ProtectedRoute>
                }
              />

              <Route
                path="/admin/reports/assignments-list"
                element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <AssignmentsReportAssignmentList />
                </ProtectedRoute>
                }
              />
              <Route
                path="/leecode-report"
                element={
                <ProtectedRoute>
                  <StudentLeetCodeList />
                </ProtectedRoute>
                }
              />
              <Route
                path="/material/create"
                element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <StudyMaterialForm />
                </ProtectedRoute>
                }
              />
            </Routes>
          </main>
        </div>
      )}
    </>
  );
}
